var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 28,
    viewBox: "0 0 33 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32.5,
    height: 28,
    rx: 10,
    fill: "#FFCACA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14.8571C9 11.0108 12.118 7.89282 15.9643 7.89282C19.8106 7.89282 22.9286 11.0108 22.9286 14.8571C22.9286 18.7034 19.8106 21.8214 15.9643 21.8214C12.118 21.8214 9 18.7034 9 14.8571ZM16.7143 12C16.7143 11.5858 16.3785 11.25 15.9643 11.25C15.5501 11.25 15.2143 11.5858 15.2143 12V14.5895C15.2143 15.0075 15.4232 15.3978 15.7709 15.6296L17.6911 16.9097C18.0358 17.1395 18.5014 17.0464 18.7312 16.7017C18.9609 16.3571 18.8678 15.8914 18.5232 15.6616L16.7143 14.4557V12Z",
    fill: "#3B3B3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5356 7L22.3928 9.14286",
    stroke: "#3B3B3C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9644 7L15.9644 8.42857",
    stroke: "#3B3B3C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5356 20.5714L20.2499 22",
    stroke: "#3B3B3C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3931 20.5714L11.6788 22",
    stroke: "#3B3B3C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3931 7L9.53592 9.14286",
    stroke: "#3B3B3C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC1);
export default __webpack_public_path__ + "static/media/c1.0a53dae3ea1990ce972120200d5a7904.svg";
export { ForwardRef as ReactComponent };